import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';
import { useAuth } from "../../AuthContext";
import useIsMobile from "../../hooks/isMobile"
import Dropdown from "components/Dropdown/Dropdown";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";

export default function Navbar() {



    const { user, player, membership = {} } = useAuth({});
    const [activeLink, setActiveLink] = useState(null);

    let leagueId = player?.leagueId ? player?.leagueId : "p7rV0fyVsJqBFtysklEj"

    let handleOnClick = (index, e) => {
        setActiveLink(index)
    }

    const isMobile = useIsMobile();


    const mainNavItems = [

        {
            text: "Rundor",
            to: `/league/${leagueId}/rounds`,
            icon: "LandPlot",
            authReq: false

        }, {
            text: "Spelare",
            to: `/league/${leagueId}/players`,
            icon: "UsersRound",
            authReq: false

        },
        {
            text: "Inlägg",
            to: `/league/${leagueId}/posts`,
            icon: "ScrollText",
            authReq: false

        },
        {
            text: "Info",
            to: `/league/${leagueId}/info`,
            icon: "Library",
            authReq: false

        }
    ]

    const secondaryNavItems = [
        {
            text: "Registrera runda",
            to: `/league/${leagueId}/register-round`,
            icon: "NotepadText",
            authReq: true

        },
        {
            text: "Skapa inlägg",
            to: `/league/${leagueId}/create-post`,
            icon: "MessageCirclePlus",
            authReq: true

        },
        {
            text: "Ladda upp",
            to: `/league/${leagueId}/upload`,
            icon: "Plus",
            authReq: true

        },
        {
            text: "Lottning",
            to: `https://ligalottning.expo.app`,
            icon: "Dices",
            authReq: false
        },
        ...(membership?.role === "admin" ? [{
            text: "Inbjudningar",
            to: `/league/${leagueId}/admin/invites`,
            icon: "UserPlus",
            authReq: true
        }] : []),


    ]
    const signOutItem = {
        text: "Logga ut",
        icon: "LogOut",
        authReq: false,
        onAction: () => signOut(auth),
    };

    const signInItem = {
        text: "Logga in",
        to: "/login",
        icon: "LogIn",
        authReq: false,
    };

    const mergedSecondaryNavItems = isMobile
        ? [
            ...mainNavItems.map(item => ({
                ...item,
                icon: item.icon || "Menu"
            })),
            ...secondaryNavItems,
            user ? signOutItem : signInItem,
        ]
        : [
            ...secondaryNavItems,
            user ? signOutItem : signInItem,
        ];


    return (
        <div className="navbar">

            <div className="sub-nav main-menu">
                <NavLink className={`nav-item nav-item--large`} to={"/"}> Svärmorsdrömmar</NavLink>

                {!isMobile && mainNavItems.map((item, index) => {
                    if (item.authReq && !user) return null;
                    return <NavLink
                        key={item.text}
                        to={item.to}
                        className={({ isActive }) =>
                            `nav-item ${item.extraClass || ""} ${isActive ? "nav-item--active" : ""}`
                        }
                    >
                        {item.text}
                    </NavLink>

                })}

            </div>
            <div className="sub-nav secondary-menu">
                {membership?.role === "admin" || membership?.role === "member" ?
                    <Dropdown
                        secondaryNavItems={mergedSecondaryNavItems}
                        user={user}
                        activeLink={activeLink}
                        handleOnClick={handleOnClick}
                        iconName="Menu"
                        secondaryIconName="X"

                    /> :
                    isMobile ? <Dropdown
                        secondaryNavItems={mergedSecondaryNavItems}
                        user={user}
                        activeLink={activeLink}
                        handleOnClick={handleOnClick}
                        iconName="Menu"
                        secondaryIconName="X"

                    /> :
                        <button className="button button--standard"><a href="/login">Logga in</a></button>}

            </div>

        </div >
    )
}
